import {Box} from "@chakra-ui/react";
import {Field as ChakraField} from "@chakra-ui/react";
import {InfoIcon} from "lucide-react";
import React from "react";
import {LanguageInput} from "@/components";

export const LanguageField = ({renderElement, id, label, errors, defaultLanguage = null, ...props}) => {

    return (
        <Box width="100%" {...props}>
            <ChakraField.Root invalid={!!errors} display="flex" flexDirection="column" h="100%">
                <LanguageInput
                    id={id}
                    defaultLanguage={defaultLanguage}
                    label={label
                        ? <ChakraField.Label flex={1} fontSize="small" as="b">
                            {label}
                        </ChakraField.Label>
                        : null
                    }
                    renderElement={renderElement}
                />
                <ChakraField.ErrorText>
                    <InfoIcon/>
                    {errors}
                </ChakraField.ErrorText>
            </ChakraField.Root>
        </Box>
    );
};

export default LanguageField;
